import React from 'react';
import LocalSearchDropdown from './LocalSearchDropdown';
import documentTypes from '../utils/documentTypes';


const DocumentTypeDropdown = (props) => (
  <LocalSearchDropdown
    {...props}
    mapText={
      (documentType) => {
        return documentType.text
      }
    }
    mapToSearchString={
      (documentType) => {
        return documentType.text
      }
    }
    headers={['Search Document Types', 'Filter by tag']}
    options={documentTypes}/>
)

export default DocumentTypeDropdown;



// WEBPACK FOOTER //
// ./src/component/DocumentTypeDropdown.js